<template>
    <div>
        <v-toolbar flat dense app color="primary" dark>
            <v-toolbar-side-icon @click.stop="drawer()"></v-toolbar-side-icon>
            <v-toolbar-title>Caixas Offline</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.stop="load">
                <v-icon>autorenew</v-icon>
            </v-btn>
        </v-toolbar>

        <v-list two-line subheader v-if="caixas" style="margin-top: 10px">
            <template v-for="item in caixas" >
                <div :key="item._id">
                    <v-list-tile  avatar @click="goTo(item._id)">

                        <v-list-tile-avatar>
                            <v-icon class="red" :class="[iconClass]">signal_wifi_off</v-icon>
                        </v-list-tile-avatar>

                        <v-list-tile-content>

                            <v-list-tile-sub-title>
                                <b>{{ item.nome }}</b>
                            </v-list-tile-sub-title>

                            <v-list-tile-sub-title>
                                Desde: {{ item.info.offline_time | date('DD/MM/YYYY HH:mm:ss')}}
                            </v-list-tile-sub-title>

                            <v-list-tile-sub-title>
                                Status: {{ item.info.status}}
                            </v-list-tile-sub-title>

                        </v-list-tile-content>

                        <v-list-tile-action>
                            <v-btn icon ripple>
                                <v-icon color="grey lighten-1">keyboard_arrow_right</v-icon>
                            </v-btn>
                        </v-list-tile-action>

                    </v-list-tile>
                    <v-divider></v-divider>
                </div>
            </template>
        </v-list>
    </div>
</template>

<script>
    import { Caixas } from "../../class/caixas"
    import { EventBus } from "../../utils/event-bus.js"
    import { date } from "../../filters"

    export default {
        name: "CaixasOffline",
        data () {
            return {
                search_text: null,
                iconClass: "white--text",
                search: false,
                caixas: null
            }
        },
        filters: {
            date
        },
        beforeMount () {
            this.load()
        },
        methods: {
            load () {
                Caixas
                    .offline()
                    .then(ordens => {
                        this.caixas = ordens.data.caixas
                    })
                    .catch((err) => console.error(err))
            },
            drawer: () => {
                EventBus.$emit("drawer", true)
            },
            goTo (id) {
                this.$router.push("/caixa/" + id)
            }
        }
    }
</script>

<style scoped>

</style>
